import * as angular from "angular";

export class StateService {
  previousState: string;
  previousStateParams: any;

  constructor() {
  }

  setPreviousState(previousState) {
    this.previousState = previousState;
  }

  setPreviousStateParams(params) {
    this.previousStateParams = params;
  }

  getPreviousState() {
    return this.previousState;
  }

  getPreviousStateParams() {
    return this.previousStateParams || {};
  }


}

angular
  .module('bringoz.admin.commons')
  .service('stateService', StateService);
